import { useEffect, useState } from 'react';
import { t } from 'i18next';

const DEFAULT_LIST_TAB = [
  {
    id: 'posts',
    text: t('userFeedProfilePage.postTab')
  },
  {
    id: 'anonymous',
    text: t('userFeedProfilePage.anonymousTab')
  },
  {
    id: 'comments',
    text: t('userFeedProfilePage.commentTab')
  }
];

interface TabsListSelectorProps {
  onSelectedTab: (tab: { id: string; text: string }) => void;
  tabsList?: typeof DEFAULT_LIST_TAB;
  hiddenTabId: string;
}

const TabsListSelector = ({
  onSelectedTab,
  tabsList = DEFAULT_LIST_TAB,
  hiddenTabId
}: TabsListSelectorProps) => {
  const [selectedTab, setSelectedTab] = useState(tabsList[0]);

  useEffect(() => {
    if (onSelectedTab) {
      onSelectedTab(selectedTab);
    }
  }, [onSelectedTab, selectedTab]);

  return (
    <div className="py-[14px]">
      <div className="flex items-center gap-[12px]">
        {tabsList
          ?.filter((tab) => tab.id !== hiddenTabId)
          ?.map((tab) => (
            <button key={tab.id} type="button" onClick={() => setSelectedTab(tab)}>
              {tab.id === selectedTab?.id ? (
                <p className="text-primary-light dark:text-primary-dark border-b-[2px] border-primary-light dark:border-primary-dark text-[15px] font-bold leading-[18px] text-left pb-[2px]">
                  {tab.text}
                </p>
              ) : (
                <p className="text-text-main-lv2 text-[15px] font-medium leading-[18px] text-left pb-[4px]">
                  {tab.text}
                </p>
              )}
            </button>
          ))}
      </div>
    </div>
  );
};

export default TabsListSelector;
